import {
    DeleteOutlined,
    EditFilled,
    EyeOutlined,
    MoreOutlined,
  } from "@ant-design/icons";
  import {
    Box,
    Card,
    CardMedia,
    IconButton,
    Menu,
    MenuItem,
    Typography,
    Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
  } from "@mui/material";
  import dayjs from "dayjs";
  import { useEffect, useRef, useState,forwardRef, useImperativeHandle } from "react";
  import { useNotification } from "../../../hooks/useNotification.js";
  import { JournalAPIService } from "../../../services/api/JournalAPIService";
  import {
    API_ERROR_MESSAGE,
    API_SUCCESS_MESSAGE,
    DATE,
  } from "../../../shared/constants";
  import ConfirmationDialog from "../../common/ConfirmationDialog.js";
  import VideoCardTemplateEdit from "./VideoTemplateEdit";
  import ImageEditor from "../../../pages/Memory_journal/ImageEditor.js";
  import magicToolIcon from "../../../assests/Images/magicTool.png";
import info from "../../../assests/Images/info.png";
  import info1 from "../../../assests/Images/info1.png";
import info2 from "../../../assests/Images/info2.png";
import info3 from "../../../assests/Images/info3.png";
  import ActionMenu from "../../../pages/Extra/ActionMenu.js";
  import html2canvas from "html2canvas";
  import DownloadBackdrop from "../../../pages/Memory_journal/DownloadBackdrop.js";
  import { FFmpeg } from "@ffmpeg/ffmpeg";

  const ffmpeg = new FFmpeg();

  const VideoCardTemplate = forwardRef((props,ref) => {
    const {
      journalId,
      author,
      imgSrc,
      text,
      date,
      borderColor = "#f72bb1",
      backgroundColor = "#007bff",
      imageBottomRight,
      imageBottomRightStyle,
      textColor,
      disableEye = false,
      editData = false,
      pageRefreshCallback,
      menuShow,
      phone
    } = props;

    const [imageUrl, setImageUrl] = useState(imgSrc);
    const [showEye, setShowEye] = useState(false);
    const { notifyError, notifySuccess } = useNotification();
    const [open, setOpen] = useState(false);
    const [editMode, setEditOpen] = useState(editData);
    const [anchorEl, setAnchorEl] = useState(null);
    const textRef = useRef(null);
    const [isSingleLine, setIsSingleLine] = useState(true);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const [isEditorOpen, setIsEditorOpen] = useState(false);
    const [imageToEdit, setImageToEdit] = useState(null);
    const [imageId, setImageId] = useState(null);
    const cardRef = useRef(null);
    const [downloading, setDownloading] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);
    const openMenu = Boolean(anchorEl);


    useImperativeHandle(ref, () => ({
      getCardElement: () => cardRef.current,
    }));

    const handleOpenEditor = (url, id) => {
      handleCloseDialog();
      setImageToEdit(url);
      setImageId(id);
      setIsEditorOpen(true);
    };

    const handleCloseEditor = () => {
      setIsEditorOpen(false);
      setImageToEdit(null);
      setImageId(null);
    };

    const handleMenuClick = (action) => {
      switch (action) {
        case "edit":
          handleEdit();
          break;
        case "delete":
          handleDelete();
          break;
        case "effect":
          handleOpenEditor(imageUrl, journalId);
          break;
        case "view":
          handleOpenDialog();
            break;
        case "save":
          handleDownloadVideo();
          break;
        case "drag":
          console.log("Drag action triggered");
          // Optional: set some dragging state here
          break;
        default:
          break;
      }
    };

    const handleMenuClose = () => {
      setAnchorEl(null);
      setShowEye(false);
    };

    const handleOpenDialog = () => setOpen(true);
    const handleCloseDialog = () => {
      setOpen(false);
      setEditOpen(false);
      setShowEye(false);
    };

    const handleEdit = () => {
      if (!disableEye) {
        setOpen(true);
      }
      setShowEye(false);
      setEditOpen(true);
    };

    const handleCancelDelete = () => {
      setConfirmDialogOpen(false);
    };

    const handleDelete = () => {
      handleCloseDialog();
      setConfirmDialogOpen(true);
    };

    const handleConfirmDelete = () => {
      setConfirmDialogOpen(false);

      JournalAPIService.journalDelete(journalId)
        .then((response) => {
          notifySuccess(
            response.message || API_SUCCESS_MESSAGE.DELETED_SUCCESSFULLY
          );
          pageRefreshCallback();
        })
        .catch((errResponse) => {
          notifyError(
            errResponse?.response?.data?.message ||
              API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR
          );
        });
      handleCloseDialog();
    };

    useEffect(() => {
      const element = textRef.current;
      if (element) {
        const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
        const height = element.clientHeight;

        // If height is more than 1.5x the lineHeight, we assume it's multiline
        if (height > lineHeight * 1.2) {
          setIsSingleLine(false);
        } else {
          setIsSingleLine(true);
        }
      }
    }, [text]);

    const handleDownloadImage = async () => {
      if (!cardRef.current) return;

      try {
        setDownloading(true);

      const canvas = await html2canvas(cardRef.current, {
          useCORS: true,
          backgroundColor: null,
          // scale: 2,
          allowTaint: true,
          logging: false,
          removeContainer: true,
          imageTimeout: 15000,
        });

        const hashCode = (str) => {
          let hash = 0;
          for (let i = 0; i < str.length; i++) {
            hash = (hash << 5) - hash + str.charCodeAt(i);
            hash |= 0;
          }
          return Math.abs(hash % 10000);
        };

        const shortCode = hashCode(journalId);

        const dataUrl = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `IMG_${shortCode}.png`;
        link.click();
      } catch (error) {
        console.error("Download failed:", error);
      } finally {
        setDownloading(false);
      }
    };

    const isVideo =
      /\.(mp4|webm|ogg|m4v|mov|avi|mkv|3gpp|3gp|3g2|hevc|h265)$/i.test(imageUrl);

    const handleSave = (imageURL) => {

      const updatedUrl = `${imageURL}?t=${Date.now()}`;
      setImageUrl(updatedUrl);
      handleCloseEditor();
    };

    const generateVideoWithOverlay = async (backgroundVideo) => {

      try {
        if (!ffmpeg.loaded) await ffmpeg.load();

        const bgVideoArrayBuffer = await fetch(URL.createObjectURL(backgroundVideo)).then(res => res.arrayBuffer());

        await ffmpeg.writeFile("background.mp4", new Uint8Array(bgVideoArrayBuffer));

        // FFmpeg: overlay PNG onto video
        await ffmpeg.exec([
          "-i", "background.mp4",
          "-filter_complex",
          "scale=520:720:flags=lanczos",
          "-c:v", "libx264",
          "-pix_fmt", "yuv420p",
          "-preset", "ultrafast",
          "output_overlay.mp4"
        ]);
        const data = await ffmpeg.readFile("output_overlay.mp4");
        const url = URL.createObjectURL(new Blob([data.buffer], { type: "video/mp4" }));
        // Auto-download the file
      const a = document.createElement("a");
      a.href = url;
      a.download = "Joy_Memory.mp4";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setOpenInfo(true);

      // Optional: Revoke the URL after some time to free memory
      setTimeout(() => URL.revokeObjectURL(url), 1000);

        // setVideoUrl(url);
      } catch (error) {
        console.error("Error generating overlay video:", error);
      }
    };


    const handleDownloadVideo = async () => {
      if (!cardRef.current) return;

      try {
        setDownloading(true);

        // Use your own video path here
        const backgroundVideo = await fetch(imageUrl).then(res => res.blob());; // put this in your public folder

        await generateVideoWithOverlay(backgroundVideo);
      } catch (err) {
        console.error("Video generation failed:", err);
        notifyError("Video generation failed.");
      } finally {
        setDownloading(false);
      }
    };


    return (
      <>
      {menuShow &&
        <IconButton
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            color: "black",
            zIndex: 1001,
            width: { xs: "25px", sm: "30px", md: "30px" },
            height: { xs: "25px", sm: "30px", md: "30px" },
            "@media (max-width: 440px)": {
              height: "20px",
              width: "20px",
              top:12,
              right:10
            },
            // bgcolor: "#ffffffc9",
          }}
          // onClick={handleMenuClick}
        >
          <ActionMenu action={handleMenuClick} edit={true} show={isVideo} drag={true} fullView={true} reel={true}/>
        </IconButton>
      }
        <div ref={cardRef} style={{width:"100%",padding: "0px",}}>
          <Card
            sx={{
              width: {
                xs: disableEye ? "96%" : "100%",
                sm: disableEye ? "60%" : "100%",
                md: disableEye ? "60%" : "100%",
              },
              height: {
                xs: disableEye ? 300 : 258,
                sm: disableEye ? 375 : 346,
                md: disableEye ? 375 : 346,
              },
              "@media (max-width: 370px)": {
                height: disableEye ? 300 : 258,
              },
              "@media (min-width: 310px) and (max-width: 360px)": {
                height: 230,
              },

              borderRadius: 4,
              marginTop: {
                xs: disableEye ? "10%" : "2%",
                sm: disableEye ? "4%" : "1%",
                md: disableEye ? "4%" : "1%",
              },
              border: `4px solid ${borderColor}`,
              position: "relative",
              overflow: "visible",
              justifySelf: "center",
              bgcolor: backgroundColor || "#f9f9f9",
            }}
          >
            <Box
              sx={{
                position: "relative",
                overflow: "hidden",
                height:"100%"
              }}
              onMouseEnter={() => setShowEye(true)}
              onMouseLeave={() => setShowEye(false)}
            >


              <CardMedia
                component="video"
                image={imageUrl}
                alt="Uploaded"
                controls
                sx={{
                  objectFit: "inherit",
                  width: "100%",
                //   height: { xs: "175px", sm: "340px", md: "340px" },
                //   "@media (min-width: 310px) and (max-width: 360px)": {
                //     height: 160,
                //   },
                height:"100%",
                  borderRadius: "12px",
                }}
              />
            </Box>

          </Card>

          <ConfirmationDialog
            id="confirmation-dialog-description"
            open={confirmDialogOpen}
            title=""
            description="Are you sure you want to delete this memory?"
            onConfirm={handleConfirmDelete}
            onCancel={handleCancelDelete}
            confirmText="Delete"
            cancelText="Cancel"
            keepMounted={false}
            transition="up"
            loading={false}
          />
          {open && (
            <VideoCardTemplateEdit
              open={open}
              onClose={handleCloseDialog}
              journalId={journalId}
              imgSrc={imageUrl}
              text={text}
              author={author}
              date={date}
              borderColor={borderColor}
              backgroundColor={backgroundColor}
              imageBottomRight={imageBottomRight}
              imageBottomRightStyle={imageBottomRightStyle}
              textColor={textColor}
              disableEye={true}
              editData={editMode}
              pageRefreshCallback={pageRefreshCallback}
              handleOpenEditor={handleOpenEditor}
            />
          )}

          {isEditorOpen && (
            <Dialog fullScreen open={isEditorOpen} sx={{ zIndex: 1001 }}>
              <ImageEditor
                imageUrl={imageToEdit}
                imageId={imageId}
                onClose={handleCloseEditor}
                onSave={handleSave}
              />
            </Dialog>
          )}
        </div>
        <DownloadBackdrop downloading={downloading} />

        <Dialog open={openInfo} onClose={() => setOpenInfo(false)} sx={{zIndex:5000}}>
         <DialogTitle>📥 Find Your Download!</DialogTitle>
                <DialogContent>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 'bold', mr: 1 }}>1.</Typography>
            <Typography variant="body2">
              Look for the Download Icon ⬇️ in your browser address bar
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 'bold', mr: 1 }}>2.</Typography>
            <Typography variant="body2">
              Tap the Icon to see a list of your recent downloads. 👉 Tap the downloaded file to open it, play it or save it to your photos
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 'bold', mr: 1 }}>3.</Typography>
            <Typography variant="body2">
              Don’t See the Icon? Tap the <img src={info1} alt="Aa" width="25px" loading="eager" /> or <img src={info2} alt="download" width="25px" loading="eager" /> button in Safari’s address bar → Select “Show Downloads”
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenInfo(false)} variant="contained" sx={{color:"#ffffff", background:"#005cff"}}>Got it!</Button>
        </DialogActions>
      </Dialog>
      </>
    );
  });

  export default VideoCardTemplate;
